/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { RESOURCE_MODULE_IDS } from "config/constants";
import { requestGetSpacesMinified } from "services/settings/scheduleAdmin/relatedToScheduleAdmin";

const useSpaceList = ({
    loadingRequest,
    filters: {
        campusId, resourceModuleId, 
        spaceTypeId
    }
}) => {
    const [spaceList, setSpaceList] = useState([]);
    useEffect(() => {
        if (resourceModuleId !== RESOURCE_MODULE_IDS.UNIVERSITY_SPACES || !spaceTypeId) {
            setSpaceList([]);
            return;
        }
        fillSpaceList();
    }, [campusId, resourceModuleId, spaceTypeId]);
    const fillSpaceList = async () => {
        loadingRequest.show("Cargando espacios...");
        const data = await requestGetSpacesMinified({
            campusId, spaceTypeId
        });
        loadingRequest.hide();
        setSpaceList(data);
    }
    return spaceList;
}

export default useSpaceList;